import { render, staticRenderFns } from "./FormCreateShippingAddress.vue?vue&type=template&id=24d0c22f&scoped=true"
import script from "./FormCreateShippingAddress.vue?vue&type=script&lang=js"
export * from "./FormCreateShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./FormCreateShippingAddress.vue?vue&type=style&index=0&id=24d0c22f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0c22f",
  null
  
)

export default component.exports